import React, { useState, useRef, useEffect } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { ICON_CANCEL, ICON_SAVE } from '../../extras/icons';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { saveCharactersAction, updateCharactersAction } from '../../../actions/charactersActions';

import ButtonSpinner from '../../layout/ButtonSpinner';
import formikLocale from '../../../constants/formikLocale';
//Función principal
const CharacterForm = props => {
    //Tomo los props
    const { show, handleClose } = props;
    //Genero los refs
    const refDescription = useRef();
    //Datos iniciales
    const initialData = {
        descripcion: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const charactersLoading = useSelector( state => state.characters.loadingSave );
    const errorSave = useSelector( state => state.characters.errorSave );
    const isEdit = useSelector( state => state.characters.isEdit );
    const characterSelected = useSelector( state => state.characters.characterSelected );
    //Inicializo el state local
    const [ character, setCharacter ] = useState(initialData);
    const [ error, setError ] = useState(null);
    //Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && characterSelected){
            setCharacter(characterSelected);
        }else{
            setCharacter(initialData);
        }
    }, [isEdit, characterSelected, show])
    //Manejo de cambios
    const handleChange = e => {
        setCharacter({
            ...character,
            [e.target.name]: e.target.value
        })
    }
    //Manejo el guardado
    const handleSave = values => {
        //Inicializo los datos
        let data = {
            ...character
        }
        //Agrego los nuevos valores
        data = {
            ...data,
            ...values,
            activo: 1
        }
        //Evalúo
        if(character.id){
            //Es edición
            dispatch( updateCharactersAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( saveCharactersAction(data, handleCloseForm) );
        }
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Pongo el foco en el primer campo
        refDescription.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setCharacter(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        descripcion: yup.string().required()
    });
    //Renderizo
    return (
        <Modal show={show} onHide={handleCloseForm} onShow={handleOnShow} aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Persona Tipo&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...character }}
                onSubmit={values => handleSave(values)}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-12">
                                    <label htmlFor="description">Descripción</label>
                                    <Form.Control
                                        id="descripcion"
                                        className="form-control" 
                                        autoFocus 
                                        name="descripcion" 
                                        type="text" 
                                        value={ values.descripcion }
                                        onChange={handleChange}
                                        ref={refDescription}
                                        isInvalid={!!errors.descripcion}
                                        disabled={ charactersLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.descripcion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                charactersLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ charactersLoading }>
                                        <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ charactersLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default CharacterForm;